/* eslint-disable prefer-destructuring */
const metodosComunes = require('../metodos_comunes');

function maForAgenda(response) {
  const accionStore = 'setAccion';
  let valor = '';
  const valorCambiaPanelLateral = 3;
  const matrizActionValor = [];
  let jsonActionValor = {};
  if (response.accion === 'agenda') {
    valor = 'agenda';
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  return ([matrizActionValor, valorCambiaPanelLateral]);
}
function maForInicioLeerFormulario(response) {
  let valor = '';
  let valorCambiaPanelLateral = Number;
  const matrizActionValor = [];
  let jsonActionValor = {};
  if (response.consultar_encuentro === '1') {
    const accionStore = 'setEncuentro';
    valorCambiaPanelLateral = 5;
    valor = metodosComunes.reemplazarCaracteresEspeciales(response.encuentro);
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  } if (response.id_formulario) {
    const accionStore = 'setIdFormulario';
    valorCambiaPanelLateral = 5;
    valor = response.id_formulario;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.id_formulario) {
    const accionStore = 'setId';
    valorCambiaPanelLateral = 5;
    valor = response.id_formulario;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.encuentro_id !== 'no') {
    const accionStore = 'setId';
    valorCambiaPanelLateral = 0;
    valor = response.encuentro_id;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  } if (response.encuentro_id !== 'no' && response.encuentro !== 'no') {
    const accionStore = 'setEncuentro';
    valorCambiaPanelLateral = 0;
    valor = metodosComunes.reemplazarCaracteresEspeciales(response.encuentro);
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  } if (response.consultar_formulario === 'si') {
    const accionStore = 'setConsultarFormulario';
    valorCambiaPanelLateral = 5;
    valor = response.consultar_formulario;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  } if (response.nombre_campo) {
    const accionStore = 'setNombreCampo';
    valorCambiaPanelLateral = 5;
    valor = response.nombre_campo;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.tipo_campo) {
    const accionStore = 'setTipoCampo';
    valorCambiaPanelLateral = 5;
    valor = response.tipo_campo;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.numero_campo) {
    const accionStore = 'setNumeroCampo';
    valorCambiaPanelLateral = 5;
    valor = response.numero_campo;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.nombre_formulario) {
    const accionStore = 'setNombreFormulario';
    valorCambiaPanelLateral = 5;
    valor = response.nombre_formulario;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.momento) {
    const accionStore = 'setMomentoActual';
    valorCambiaPanelLateral = 5;
    valor = response.momento;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.evento === 'formulario') {
    matrizActionValor.push({
      accionStore: 'setColeccion',
      valor: 'formularios'
    });
  }

  return ([matrizActionValor, valorCambiaPanelLateral]);
}
function maForLeerFormulario(response) {
  let valor = '';
  const matrizActionValor = [];
  let jsonActionValor = {};
  let valorCambiaPanelLateral = Number;
  if (response.consultar_formulario === 'si') {
    const accionStore = 'setConsultarFormulario';
    valorCambiaPanelLateral = 5;
    valor = response.consultar_formulario;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.consultar_formulario === 'si') {
    const accionStore = 'setBanderaFormularioExistenteAbierto';
    valorCambiaPanelLateral = 5;
    valor = false;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.nombre_campo) {
    const accionStore = 'setNombreCampo';
    valorCambiaPanelLateral = 5;
    valor = response.nombre_campo;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.tipo_campo) {
    const accionStore = 'setTipoCampo';
    valorCambiaPanelLateral = 5;
    valor = response.tipo_campo;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.numero_campo) {
    const accionStore = 'setNumeroCampo';
    valorCambiaPanelLateral = 5;
    valor = response.numero_campo;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.id_formulario) {
    const accionStore = 'setIdFormulario';
    valorCambiaPanelLateral = 5;
    valor = response.id_formulario;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.nombre_formulario) {
    const accionStore = 'setNombreFormulario';
    valorCambiaPanelLateral = 5;
    valor = response.nombre_formulario;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  return ([matrizActionValor, valorCambiaPanelLateral]);
}
function maForVariableString(response) {
  let valor = '';
  let valorCambiaPanelLateral = Number;
  const matrizActionValor = [];
  let jsonActionValor = {};
  if (response.nombre_campo) {
    const accionStore = 'setNombreCampo';
    valorCambiaPanelLateral = 5;
    valor = response.nombre_campo;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.id_formulario) {
    const accionStore = 'setIdFormulario';
    valorCambiaPanelLateral = 5;
    valor = response.id_formulario;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.fallback === 'si') {
    const accionStore = 'setFallback';
    valorCambiaPanelLateral = 5;
    valor = 'fallback';
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.fallback === 'no' && response.valor) {
    const accionStore = 'setCampoIngresado';
    valorCambiaPanelLateral = 5;
    valor = response.valor;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.numero_campo) {
    const accionStore = 'setNumeroCampo';
    valorCambiaPanelLateral = 5;
    valor = response.numero_campo;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.tipo_campo) {
    const accionStore = 'setTipoCampo';
    valorCambiaPanelLateral = 5;
    valor = response.tipo_campo;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.numero_variable) {
    const accionStore = 'setNombreVariableActualizar';
    valorCambiaPanelLateral = 0;
    valor = response.numero_variable;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.numero_variable) {
    const accionStore = 'setValorVariableActualizar';
    valorCambiaPanelLateral = 0;
    valor = response.valor;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  return ([matrizActionValor, valorCambiaPanelLateral]);
}
function maForVariableNumero(response) {
  let valor = '';
  let valorCambiaPanelLateral = Number;
  const matrizActionValor = [];
  let jsonActionValor = {};
  if (response.nombre_campo) {
    const accionStore = 'setNombreCampo';
    valorCambiaPanelLateral = 5;
    valor = response.nombre_campo;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.id_formulario) {
    const accionStore = 'setIdFormulario';
    valorCambiaPanelLateral = 5;
    valor = response.id_formulario;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.fallback === 'si') {
    const accionStore = 'setFallback';
    valorCambiaPanelLateral = 5;
    valor = 'fallback';
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.fallback === 'no' && response.valor) {
    const accionStore = 'setCampoIngresado';
    valorCambiaPanelLateral = 5;
    valor = response.valor;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.numero_campo) {
    const accionStore = 'setNumeroCampo';
    valorCambiaPanelLateral = 5;
    valor = response.numero_campo;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.tipo_campo) {
    const accionStore = 'setTipoCampo';
    valorCambiaPanelLateral = 5;
    valor = response.tipo_campo;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  return ([matrizActionValor, valorCambiaPanelLateral]);
}
function fbForVariableFecha(response) {
  let valor = '';
  let valorCambiaPanelLateral = Number;
  const matrizActionValor = [];
  let jsonActionValor = {};
  if (response.fallback === 'si') {
    const accionStore = 'setFallback';
    valorCambiaPanelLateral = 5;
    valor = 'fallback';
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  } if (response.nombre_campo) {
    const accionStore = 'setNombreCampo';
    valorCambiaPanelLateral = 5;
    valor = response.nombre_campo;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.numero_campo) {
    const accionStore = 'setNumeroCampo';
    valorCambiaPanelLateral = 5;
    valor = response.numero_campo;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.tipo_campo) {
    const accionStore = 'setTipoCampo';
    valorCambiaPanelLateral = 5;
    valor = response.tipo_campo;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  return ([matrizActionValor, valorCambiaPanelLateral]);
}
function maForVariableFecha(response) {
  let valor = '';
  let valorCambiaPanelLateral = Number;
  const matrizActionValor = [];
  let jsonActionValor = {};
  if (response.nombre_campo) {
    const accionStore = 'setNombreCampo';
    valorCambiaPanelLateral = 5;
    valor = response.nombre_campo;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.id_formulario) {
    const accionStore = 'setIdFormulario';
    valorCambiaPanelLateral = 5;
    valor = response.id_formulario;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.fallback === 'si') {
    const accionStore = 'setFallback';
    valorCambiaPanelLateral = 5;
    valor = 'fallback';
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.fallback === 'no' && response.valor) {
    const accionStore = 'setCampoIngresado';
    valorCambiaPanelLateral = 5;
    // valor = `${response.valor.slice(8, 10)}/${response.valor.slice(5, 7)}/${response.valor.slice(0, 4)}`;
    valor = response.valor;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.numero_campo) {
    const accionStore = 'setNumeroCampo';
    valorCambiaPanelLateral = 5;
    valor = response.numero_campo;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.tipo_campo) {
    const accionStore = 'setTipoCampo';
    valorCambiaPanelLateral = 5;
    valor = response.tipo_campo;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  return ([matrizActionValor, valorCambiaPanelLateral]);
}
function maForFormularioNuevamente(response) {
  let valor = '';
  let valorCambiaPanelLateral = Number;
  const matrizActionValor = [];
  let jsonActionValor = {};
  if (response.fin_formulario === 'Si') {
    const accionStore = 'setNombreCampo';
    valorCambiaPanelLateral = 0;
    valor = null;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  return ([matrizActionValor, valorCambiaPanelLateral]);
}
function fbForVariableNumero(response) {
  let valor = '';
  let valorCambiaPanelLateral = Number;
  const matrizActionValor = [];
  let jsonActionValor = {};
  if (response.fallback === 'si') {
    const accionStore = 'setFallback';
    valorCambiaPanelLateral = 5;
    valor = 'fallback';
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  } if (response.nombre_campo) {
    const accionStore = 'setNombreCampo';
    valorCambiaPanelLateral = 5;
    valor = response.nombre_campo;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.numero_campo) {
    const accionStore = 'setNumeroCampo';
    valorCambiaPanelLateral = 5;
    valor = response.numero_campo;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.tipo_campo) {
    const accionStore = 'setTipoCampo';
    valorCambiaPanelLateral = 5;
    valor = response.tipo_campo;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  return ([matrizActionValor, valorCambiaPanelLateral]);
}
function maForTerminar(response) {
  let valor = '';
  let valorCambiaPanelLateral = Number;
  const matrizActionValor = [];
  let jsonActionValor = {};
  if (response.evento === 'encuentros') {
    matrizActionValor.push({
      accionStore: 'setIdFormulario',
      valor: null
    });
    matrizActionValor.push({
      accionStore: 'setVariablesFormularios',
      valor: []
    });
    matrizActionValor.push({
      accionStore: 'setNombreFormulario',
      valor: null
    });
    matrizActionValor.push({
      accionStore: 'setMomentoActual',
      valor: null
    });
  }
  if (response.reinicio === 'si') {
    const accionStore = 'setFormularios';
    valorCambiaPanelLateral = 0;
    valor = null;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.reinicio === 'si') {
    const accionStore = 'setMomentosEncuentro';
    valorCambiaPanelLateral = 0;
    valor = null;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.textoGenerado) {
    const accionStore = 'setTextoGenerado';
    valorCambiaPanelLateral = 0;
    valor = response.textoGenerado;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.encuentro_id != 'no') {
    const accionStore = 'setId';
    valorCambiaPanelLateral = 0;
    valor = response.encuentro_id;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.encuentro_id != 'no') {
    const accionStore = 'setOrdenesAutomaticasEncuentro';
    valorCambiaPanelLateral = 0;
    valor = true;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  return ([matrizActionValor, valorCambiaPanelLateral]);
}

function maForTerminarFormularioIncompleto(response) {
  let valor = '';
  let valorCambiaPanelLateral = Number;
  const matrizActionValor = [];
  let jsonActionValor = {};
  if (response.nombre_campo) {
    const accionStore = 'setNombreCampo';
    valorCambiaPanelLateral = 5;
    valor = response.nombre_campo;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  // if (response.id_formulario) {
  //   const accionStore = 'setIdFormulario';
  //   valorCambiaPanelLateral = 5;
  //   valor = response.id_formulario;
  //   jsonActionValor = {
  //     valor,
  //     accionStore,
  //   };
  //   matrizActionValor.push(jsonActionValor);
  // }
  return ([matrizActionValor, valorCambiaPanelLateral]);
}
function maForEscogerEvento(response) {
  let valor = '';
  let valorCambiaPanelLateral = Number;
  const matrizActionValor = [];
  let jsonActionValor = {};
  if (response.evento) {
    const accionStore = 'setEscogerEvento';
    valorCambiaPanelLateral = 0;
    valor = response.evento;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  return ([matrizActionValor, valorCambiaPanelLateral]);
}
function maForVerPacientes(response) {
  let valor = '';
  let valorCambiaPanelLateral = Number;
  const matrizActionValor = [];
  let jsonActionValor = {};
  if (response.ver.toLowerCase() === 'si') {
    const accionStore = 'setVerAgenda';
    valorCambiaPanelLateral = 3;
    valor = response.ver.toLowerCase();
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  return ([matrizActionValor, valorCambiaPanelLateral]);
}
function maForPacienteSiguiente(response) {
  let valor = '';
  let valorCambiaPanelLateral = Number;
  const matrizActionValor = [];
  let jsonActionValor = {};
  if (response.siguiente.toLowerCase() === 'si') {
    const accionStore = 'setSiguiente';
    valorCambiaPanelLateral = 0;
    valor = response.siguiente.toLowerCase();
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.cedula) {
    const accionStore = 'setCedulaPaciente';
    valorCambiaPanelLateral = 0;
    valor = response.cedula;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  return ([matrizActionValor, valorCambiaPanelLateral]);
}
function maForHc(response) {
  let valor = '';
  let valorCambiaPanelLateral = Number;
  const matrizActionValor = [];
  let jsonActionValor = {};
  if (response.resumen === 'si') {
    const accionStore = 'setResumenHC';
    valorCambiaPanelLateral = 4;
    valor = response.resumen.toLowerCase();
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  return ([matrizActionValor, valorCambiaPanelLateral]);
}
function maForHcFormulario(response) {
  let valor = '';
  let valorCambiaPanelLateral = Number;
  const matrizActionValor = [];
  let jsonActionValor = {};
  if (response.resumen === 'no' && response.especifico == 'si') {
    const accionStore = 'setEspecificoHC';
    valorCambiaPanelLateral = 4;
    valor = response.especifico.toLowerCase();
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.nombre_formulario) {
    const accionStore = 'setNombreFormularioEspecifico';
    valorCambiaPanelLateral = 4;
    valor = response.nombre_formulario;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  return ([matrizActionValor, valorCambiaPanelLateral]);
}
function mcForTerminarFormularioMomento(response) {
  let valor = '';
  let valorCambiaPanelLateral = Number;
  const matrizActionValor = [];
  let jsonActionValor = {};
  if (response.momento) {
    const accionStore = 'setMomentoActual';
    valorCambiaPanelLateral = 5;
    valor = response.momento;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  return ([matrizActionValor, valorCambiaPanelLateral]);
}
function maForSalirFormulario(response) {
  let valor = '';
  let valorCambiaPanelLateral = Number;
  const matrizActionValor = [];
  let jsonActionValor = {};
  if (response.nombre_campo) {
    const accionStore = 'setNombreCampo';
    valorCambiaPanelLateral = 5;
    valor = response.nombre_campo;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.nombre_campo) {
    const accionStore = 'setCancelarFormulario';
    valorCambiaPanelLateral = 5;
    valor = response.nombre_campo;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  return ([matrizActionValor, valorCambiaPanelLateral]);
}
function maForCambiarMomento(response) {
  let valor = '';
  let valorCambiaPanelLateral = Number;
  const matrizActionValor = [];
  let jsonActionValor = {};
  if (response.momento) {
    const accionStore = 'setMomentoActual';
    valorCambiaPanelLateral = 5;
    valor = response.momento;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  return ([matrizActionValor, valorCambiaPanelLateral]);
}
function maForSeguimientoOpcion(response) {
  let valor = '';
  let valorCambiaPanelLateral = Number;
  const matrizActionValor = [];
  let jsonActionValor = {};
  if (response.nombreEvento) {
    const accionStore = 'setNombreEvento';
    valorCambiaPanelLateral = 8;
    valor = response.nombreEvento;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.documento) {
    const accionStore = 'setCedulaPaciente';
    valorCambiaPanelLateral = 8;
    valor = response.documento;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.cedula) {
    const accionStore = 'setCedulaPaciente';
    valorCambiaPanelLateral = 8;
    valor = response.cedula;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.id) {
    const accionStore = 'setId';
    valorCambiaPanelLateral = 8;
    valor = response.id;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.evento) {
    const accionStore = 'setColeccion';
    valorCambiaPanelLateral = 8;
    valor = response.evento;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  if (response.evento) {
    const accionStore = 'setColeccion';
    valorCambiaPanelLateral = 8;
    valor = response.evento;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  return ([matrizActionValor, valorCambiaPanelLateral]);
}

function maForSeguimientoTerminar(response) {
  let valor = '';
  let valorCambiaPanelLateral = Number;
  const matrizActionValor = [];
  let jsonActionValor = {};
  if (response.cedula) {
    const accionStore = 'setCedulaPaciente';
    valorCambiaPanelLateral = 0;
    valor = response.cedula;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  return ([matrizActionValor, valorCambiaPanelLateral]);
}
function maForSeguimientoCancelar(response) {
  let valor = '';
  let valorCambiaPanelLateral = Number;
  const matrizActionValor = [];
  let jsonActionValor = {};
  if (response.cedula) {
    const accionStore = 'setCedulaPaciente';
    valorCambiaPanelLateral = 0;
    valor = response.cedula;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  return ([matrizActionValor, valorCambiaPanelLateral]);
}
function maForSeguimientoOrdenes(response) {
  let valor = '';
  let valorCambiaPanelLateral = Number;
  const matrizActionValor = [];
  let jsonActionValor = {};
  if (response.cedula) {
    const accionStore = 'setCedulaPaciente';
    valorCambiaPanelLateral = 13;
    // valorCambiaPanelLateral = 0;
    valor = Number(response.cedula);
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  return ([matrizActionValor, valorCambiaPanelLateral]);
}
module.exports.formulariosEstados = function formulariosEstados(action, response) {
  return new Promise((resolve, reject) => {
    switch (action) {
      case 'ma_for_agenda':
        resolve(maForAgenda(response));
        break;
      case 'ma_for_inicio_leer_formulario':
        resolve(maForInicioLeerFormulario(response));
        break;
      case 'ma_for_leer_formulario':
        resolve(maForLeerFormulario(response));
        break;
      case 'ma_for_variable_string':
        resolve(maForVariableString(response));
        break;
      case 'fb_for_variable_fecha':
        resolve(fbForVariableFecha(response));
        break;
      case 'ma_for_variable_fecha':
        resolve(maForVariableFecha(response));
        break;
      case 'ma_for_formulario_nuevamente':
        resolve(maForFormularioNuevamente(response));
        break;
      case 'fb_for_variable_numero':
        resolve(fbForVariableNumero(response));
        break;
      case 'ma_for_variable_numero':
        resolve(maForVariableNumero(response));
        break;
      case 'ma_for_terminar':
        resolve(maForTerminar(response));
        break;
      case 'ma_for_terminar_formulario_incompleto':
        resolve(maForTerminarFormularioIncompleto(response));
        break;
      case 'ma_for_escoger_evento':
        resolve(maForEscogerEvento(response));
        break;
      case 'ma_for_ver_pacientes':
        resolve(maForVerPacientes(response));
        break;
      case 'ma_for_paciente_siguiente':
        resolve(maForPacienteSiguiente(response));
        break;
      case 'ma_for_hc':
        resolve(maForHc(response));
        break;
      case 'ma_for_hc_formulario':
        resolve(maForHcFormulario(response));
        break;
      case 'mc_for_terminar_formulario_momento':
        resolve(mcForTerminarFormularioMomento(response));
        break;
      case 'ma_for_salir_formulario':
        resolve(maForSalirFormulario(response));
        break;
      case 'ma_for_cambiar_momento':
        resolve(maForCambiarMomento(response));
        break;
      case 'ma_for_seguimiento_opcion':
        resolve(maForSeguimientoOpcion(response));
        break;
      case 'ma_for_seguimiento_terminar':
        resolve(maForSeguimientoTerminar(response));
        break;
      case 'ma_for_seguimiento_cancelar':
        resolve(maForSeguimientoCancelar(response));
        break;
      case 'ma_for_seguimiento_ordenes':
        resolve(maForSeguimientoOrdenes(response));
        break;
      default:
        // eslint-disable-next-line prefer-promise-reject-errors
        reject('Error');
        break;
    }
  });
};



// WEBPACK FOOTER //
// ./src/js/modulosChatBox/formularios.js